import { Component } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { MeetingService } from '../../services/meeting.service';
import { ToasterService } from 'angular2-toaster';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import * as moment from 'moment';

declare var document: any;
declare var $: any;

// declare var document: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent {

  busy: Promise<any>;
  hours: any = '';
  paidHours: number;
  recurringHours: number;

  authcode: any = '';
  user: any = [];
  collection: any = [];
  upcoming: any = [];
  userdata: any = [];
  f_name: any;
  l_name: any;
  email: any;
  c_name: any;
  pass: any;
  phone: any;
  mnth: any;
  Date: any;
  u_msg: any;
  interval: any;
  date_eve: any;

  // pagination variable for page number
  p: any;

  e_name;

  upcomingMeetingsDisplayed: any = [];

  constructor(
    private storage: LocalStorageService,
    public router: Router,
    private _cookieService: CookieService,
    public meetingService: MeetingService,
    private toasterService: ToasterService) {

    const val = this.storage.get('user');

    if (val) {
      this.user = val;
      this.authcode = val[0].authcode;
    } else {
      const link = ['/login'];
      this.router.navigate(link);
    }


    this.u_msg = this._cookieService.get('updt_msg');
    // //  (this.u_msg);
    window.scrollTo(0, 0);
    this.interval = setTimeout(() => {
      this._cookieService.remove('updt_msg');
      this.u_msg = '';
      $('.alert').fadeTo(2000, 500).slideUp(500, function() {
         $('.alert').slideUp(500);
      });
    }, 30000);
    this.Date = new Date();
    const mn = new Date();
    this.mnth = mn.getMonth();
    this.getTransaction();
  }

  getavailHours() {
    this.meetingService.getavailHours(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
          this.paidHours = response.paidhours;
          this.recurringHours = response.recurhours;
          this.hours = response.hours;
          this.user[0].hours = this.hours;
          this.storage.set('user', this.user);
      }
      }
    });
  }

  getTransaction() {
    this.busy = this.meetingService.getTransaction(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        this.collection = response;
        this.upcomingMeeting();
      }
      }
    });
  }

  addHours(id) {
    //  (id);
    this.meetingService.GetSavedCards(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        if (response === '') {
          if (this.storage.get('select_city_id')) {
            const cid = this.storage.get('select_city_id');
            window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=' + cid, '_blank');
          } else {
            window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=0', '_blank');
          }
          //  ("no saved card found");
        } else {
          this.storage.set('open_from_addhours', 'yes');
          setTimeout(function() {
              (<any>$('#myModal')).modal('show');
          }, 500);

        }
      }
      } else {
        //  ("error");
      }
    });
  }

  getSavedCard() {
    // this.eventremember();
    if (this.storage.get('open_from_addhours') && this.storage.get('open_from_addhours') === 'yes') {
      // $('#saved_card').modal('hide');
      // var cardid = card.cardid;
      // var cvv = document.getElementById('cvv_'+cardid).value;
      // this.storage.set('cardid',cardid);
      // this.storage.set('cvvnum',cvv);
      const link = ['/makepayment'];
      this.router.navigate(link);
    }
  }

  addhoursqry(id) {
    // //  (id);
    // this.eventremember();
    const hour = document.getElementById('miss_hour').value;
    // //  (hour);

    const cid = this.storage.get('select_city_id') ? this.storage.get('select_city_id') : '0';

    if (hour === 5) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price2=1&city=' + cid, '_blank');
    } else if (hour === 15) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price3=1&city=' + cid, '_blank');
    } else {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price1=' + hour + '&city=' + cid, '_blank');
    }

  }

  setDisplayedUpcomingMeetings() {
    /*

      We want to create an array of object as follows

      this.upcomingMeetingsDisplayed = [
        {
          month: 'February 2019',
          meetings: [
            {
              start: '2019-02-13T18:25:43.511Z',
              end: '2019-02-13T18:25:46.511Z',
              description: 'Test 1',
              address: '4003, Okahwe Street'
            },
            {
              start: '2019-02-21T18:25:43.511Z',
              end: '2019-02-21T18:25:46.511Z',
              description: 'Test 1',
              address: '4003, Okahwe Street'
            }
          ]
        },
        {
          month: 'March 2019',
          meetings: [
            {
              start: '2019-03-11T18:25:43.511Z',
              end: '2019-03-11T18:45:46.511Z',
              description: 'Test 1',
              address: '4003, Okahwe Street'
            },
            {
              start: '2019-03-23T18:05:43.511Z',
              end: '2019-03-23T18:35:46.511Z',
              description: 'Test 1',
              address: '4003, Okahwe Street'
            }
          ]
        }
      ]

    */

    this.upcomingMeetingsDisplayed = [];
    // const maxDisplayed = 5; // Maximum number of meetings to be displayed
    const upcomingMeetingsDisplayed = [];

    for (let i = 0; i < this.upcoming.length /*&& i < maxDisplayed*/; i++) {

      const thisMonth = moment(this.upcoming[i].start, 'YYYY-MM-DD HH:mm:ss').format('MMMM YYYY');

      // Get current month meetings that have previously been added to month Object
      const currentMonthMeetings =
        upcomingMeetingsDisplayed[thisMonth] && upcomingMeetingsDisplayed[thisMonth].meetings ?
          upcomingMeetingsDisplayed[thisMonth].meetings :
          [];

      // Create a new month object in the array
      upcomingMeetingsDisplayed[thisMonth] = {
        month: thisMonth,
        meetings: [
          ...currentMonthMeetings, ...this.upcoming[i]
        ]
      };
    }

    // Add items to be displayed to component variable/property so it is available in the view
    for (const key in upcomingMeetingsDisplayed) {
      if (upcomingMeetingsDisplayed.hasOwnProperty(key)) {
        this.upcomingMeetingsDisplayed.push(upcomingMeetingsDisplayed[key]);
      }
    }

  }

  upcomingMeeting() {

    this.busy = this.meetingService.getAllMeetings(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        this.upcoming = response;
        this.setDisplayedUpcomingMeetings();
        this.getUserdata();
      }
      }
    });
  }

  getUserdata() {
    this.busy = this.meetingService.getUserdata(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {

        this.userdata = response;
        const default_c = response[0].defaultcity;
        this.user[0].defaultcity = default_c;
        this.storage.set('user', this.user);
        this.getavailHours();
      }
      } else {
        //  ("error");
      }
    });
  }

  goToUpdate() {
    const link = ['/update'];
    this.router.navigate(link);
  }

  goToSavedcard() {
    const link = ['/savedcard'];
    this.router.navigate(link);
  }

  addnew() {
    const link = ['/'];
    this.router.navigate(link);
  }

  eventOption(u) {
    //  (u);
    this.storage.set('select_city', u.cityname);
    this.storage.set('select_city_id', u.cityid);
    this.storage.set('select_building', u.buildingname);
    this.storage.set('select_building_id', u.buildingid);
    this.storage.set('select_room', u.roomname);
    this.storage.set('select_room_id', u.roomid);
    this.storage.set('profile_meeting', 'profile_meeting');
    this.storage.set('profile_event_date', u.start);
    const link = ['/'];
    this.router.navigate(link);

  }

  eventDelete() {
    const meeting_id = document.getElementById('delete_click').value;
    //  (meeting_id);
    this.busy = this.meetingService.eventDelete(meeting_id, this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        //  (response);
        if (response.success === 1) {
          this.toasterService.pop('success', 'Success', 'Your Meeting Deleted successfully.');
          this.upcomingMeeting();
        } else {
          this.toasterService.pop('error', 'Unable to Delete.');
        }
        this.getavailHours();
      }
      } else {
        //  ("error");
      }
    });
  }

  eventUpdate() {
    const f_time = document.getElementById('f_time').value;
    const t_time = document.getElementById('t_time').value;
    const e_name = document.getElementById('e_name').value;
    this.date_eve = document.getElementById('event_date').value;
    this.date_eve = moment(this.date_eve, 'DD-MMM-YYYY').format('YYYY-MM-DD');
    // this.date_eve = this.datePipe.transform(this.date_eve, 'yyyy-MM-dd');
    //  (e_name);
    const time_from = this.date_eve + ' ' + f_time + ':00';
    const time_to = this.date_eve + ' ' + t_time + ':00';
    //  (time_from);
    //  (time_to);
    const meeting_id = document.getElementById('delete_click').value;
    //  (meeting_id);
    this.busy = this.meetingService.eventEdit(meeting_id, this.authcode, time_from, time_to, e_name).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        //  (response);
        if (response.success === 1) {
          this.toasterService.pop('success', 'Success', 'Your Meeting Updated successfully.');
          this.upcomingMeeting();
        } else {
          this.toasterService.pop('error', response.message);
        }
        this.getavailHours();
      }
      } else {
        //  ("error");
      }
    });
  }

  updateClick(u) {
    //  (u);

    const start_date = moment(u.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
    const end_date = moment(u.end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
    const eve_date = moment(u.start, 'YYYY-MM-DD HH:mm:ss').format('DD-MMM-YYYY');

    //  (eve_date);
    $(document).ready(function() {

      (<any>$('#myModal33')).modal('show');
      $('#e_name').val(u.description);
      $('#f_time').val(start_date);
      $('#t_time').val(end_date);
      $('#delete_click').val(u.meetingid);
      $('#curdate').empty();
      $('#curdate').append(eve_date);
      $('#delbtn').hide();
      $('#updatebtn').show();
      $('#event_date').val(eve_date);
      $('#roomname').empty();
      $('#roomname').append(u.roomname);
    });
  }

  deleteClick(u) {

    const start_date = moment(u.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
    const end_date = moment(u.end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
    const eve_date = moment(u.start, 'YYYY-MM-DD HH:mm:ss').format('DD-MMM-YYYY');

    (<any>$('#myModal33')).modal('show');
    $('#e_name').val(u.description);
    $('#f_time').val(start_date);
    $('#t_time').val(end_date);
    $('#delete_click').val(u.meetingid);
    $('#curdate').empty();
    $('#curdate').append(eve_date);
    $('#updatebtn').hide();
    $('#delbtn').show();
    $('#event_date').val(eve_date);
    $('#roomname').empty();
    $('#roomname').append(u.roomname);

  }

  signOut() {
    this.busy = this.meetingService.logout(this.authcode).subscribe(response => {
      if (response) {
        if (response[0].success === 1) {
          //  (response);
          this.storage.remove('user');
          this.storage.remove('select_city');
          this.storage.remove('select_city_id');
          this.storage.remove('select_building');
          this.storage.remove('select_building_id');
          this.storage.remove('select_room');
          this.storage.remove('select_room_id');
          this.storage.remove('seats');
          this.authcode = null;
          this._cookieService.put('msg', response[0].message);
          const link = ['/login'];
          this.router.navigate(link);
          // this.delete_cookie('user');
          // window.location.href = "http://ovo.dev.bluelightit.com/?message=Logout%20Successful";
        } else {
          this.toasterService.pop('error', response[0].message);
        }
      } else {
        //  ("error");
      }
    }, () => {
      this.signOut();
    });
    // let link = ['/login'];
    // this.router.navigate(link);
  }

  logOut(message) {

          this.storage.remove('user');
          this.storage.remove('select_city');
          this.storage.remove('select_city_id');
          this.storage.remove('select_building');
          this.storage.remove('select_building_id');
          this.storage.remove('select_room');
          this.storage.remove('select_room_id');
          this.storage.remove('seats');
          this.authcode = null;
          this._cookieService.put('msg', message);
          const link = ['/login'];
          this.router.navigate(link);

  }


}
